module.exports = __webpack_public_path__ + "static/media/battery_levels_table.925c5eac.png";